<template>
  <div
    v-tooltip="useTooltip ? tooltipOptions : false"
    @click="$emit('click')"
    :class="{
      'tile-container overflow-hidden': true,
      'px-3': padding,
      'mb-6': margin,
      scale: scale && $store.state.screenSize !== 1,
    }"
    :id="image"
  >
    <div :class="{ tile: true, br: rounded, cursor: cursor }">
      <div
        :class="{ 'bg-cont': true, br: rounded, 'bg-cont--move': moveOnMouseOver }"
        v-lazy:background-image="imgSet(image)"
      ></div>
      <slot name="tile-content"></slot>
      <div class="py-2 px-3 info" v-if="info === true">
        <h3 class="font-normal text-xl">{{ title }}</h3>
        <div class="flex justify-between text-sm">
          <span>{{ left }}</span>
          <span>{{ right }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tile',
  props: {
    title: {},
    left: {},
    right: {},
    image: {},
    info: {
      default: true,
    },
    padding: {
      default: true,
    },
    margin: {
      default: true,
    },
    rounded: {
      default: true,
    },
    scale: {
      default: true,
    },
    cursor: {
      default: true,
    },
    tooltip: {
      default: false,
    },
    alwaysTooltip: {
      default: false,
    },
    moveOnMouseOver: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    if (!this.moveOnMouseOver) {
      return;
    }

    const imageContainer = document.getElementById(this.image);
    let hasMoved = false;
    this.isTouch = false;

    this.handleTouchStart = document.addEventListener('touchstart', () => {
      this.isTouch = true;

      if (this.handleTouchStart) {
        document.removeEventListener('touchstart', this.handleTouchStart);
      }
    });

    document.addEventListener('mousemove', e => {
      if (this.isTouch || hasMoved) {
        return;
      }

      hasMoved = true;

      const clientWidth = window.innerWidth;
      const clientHeight = window.innerHeight;
      const xOffset = (e.clientX / clientWidth) * 100;
      const yOffset = (e.clientY / clientHeight) * 100;

      const el = imageContainer.children[0].children[0];

      el.style.backgroundPositionX = xOffset + '%';
      el.style.backgroundPositionY = yOffset + '%';

      setTimeout(() => {
        hasMoved = false;
      }, 10);
    });
  },

  computed: {
    useTooltip() {
      return this.alwaysTooltip || (this.tooltip !== false && this.$store.state.scale < 80);
    },
  },

  data() {
    return {
      tooltipOptions: {
        html: true,
        offset: -85,
        autoHide: false,
        content: `
        <div class="py-2 px-3 info">
        <h3 class="font-normal text-xl">${this.title}</h3>
        ${
          this.left || this.right
            ? `<div class="meta flex justify-between text-sm">
          <span>${this.left}</span>
          <span>${this.right}</span>
        </div>
      </div>`
            : ''
        }
        `,
      },
    };
  },

  methods: {
    thumb(url) {
      if (url) {
        let split = url.split('/');
        let name = split.pop();
        split.push('conversions');
        split.push(`${name.split('.')[0]}-thumb.jpg`);
        return split.join('/');
      }
    },
    imgSet(image) {
      return {
        src: image,
        loading: this.thumb(image),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.tile-container {
  &.scale {
    .tile {
      transform-style: flat;
      transform: scale(1);
    }
  }

  &.scale:hover {
    cursor: pointer;

    .tile {
      transform: scale(0.75);
    }
  }

  .tile {
    transition: transform 0.5s ease-in-out;
    position: relative;
    overflow: hidden;

    .bg-cont {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-position: center;
      background-size: cover;
      transition: filter 0.5s ease-in-out;
      filter: blur(6px);
      backface-visibility: hidden;
      background-clip: border-box;

      &--move {
        background-size: 120%;
      }

      &[lazy='loaded'] {
        filter: blur(0);
      }

      &.br {
        border-radius: 15px;
      }
    }

    &.br {
      border-radius: 15px;
    }

    & > div {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;

      &.info {
        background: #00000090;

        .meta {
          span:first-child {
            padding-right: 1rem;
          }

          span:last-child {
            padding-left: 1rem;
          }
        }
      }
    }
  }
}

:not(.full) > .tile {
  padding-top: 100%;
}

.full > .tile {
  padding-top: calc(33.33% - 0.9rem);
}

.full-height > .tile {
  padding-top: calc(200% - (1.5rem + 34px));
}
</style>
